export default "__VITE_ASSET__DP86VOUh__"